import { EMessagesActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const updateMessagesCount = actionGenerator<EMessagesActionTypes.UpdateCount, number>(
  EMessagesActionTypes.UpdateCount,
);
